export const newFormList = ["internet-i-mobilnaya-svyaz", "internet-tv-mobile"];

export const SimCardTags = [
    "dlja-zvonkov",
    "4g",
    "dlja-interneta",
    "dlja-noutbuka",
    "dlja-modema",
    "bez-abonentskoj-platy",
    "korporativnye",
    "mikro",
    "bezlimit",
    "dlja-plansheta",
    "mini",
    "nano",
    "optom",
    undefined,
];

export const tagsProvider = [
    "internet-i-mobilnaya-svyaz",
    "internet-tv-mobile",
    "domashnij-internet",
    "internet-i-tv",
    "nedorogoj-domashnij-internet",
    "internet-100-mbit",
    "internet-300-mbit",
    "internet-500-mbit",
    "online-kinoteatr",
    undefined,
];
